/**
 * Export Jurisdiction and Classification U.S. EAR99, India Not Subject to Regulations
 */
import { Box, Grid } from '@mui/material';
import { PropsWithChildren, ReactNode, useEffect, useRef, useState } from 'react';
import {Responsive as ResponsiveGridLayout,WidthProvider } from "react-grid-layout";
import { constants } from 'zlib';


interface Props {
  header?: ReactNode
  widget1?: ReactNode
  widget2?: ReactNode
  widget3?: ReactNode
  widget4?: ReactNode
  widget5?: ReactNode
  widget6?: ReactNode

};



const RGridLayout = WidthProvider(ResponsiveGridLayout)
const DashboardLayout = ({ header, widget1, widget2, widget3, widget4, widget5, widget6, children }: PropsWithChildren<Props>) => {

  const [widthscreen,setwidth] = useState(window.innerWidth);
  const breakpoint = 509;

 const handleBreakPointChange = (breakpoint:any) => {
  console.log(breakpoint)
   // this.props.setBreakPoint(breakpoint);
  };

  useEffect(()=>{

    const handleWindowSizeChange = () => {
      setwidth(window.innerWidth);
    };

    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  },[])

  
  console.log(widthscreen)
  const layout = [
    { i: "a", x: 0, y: 0, w: 6.6, h: 1 },
    { i: "b", x: 6.74, y: 0, w: 3.23, h: 1 },
    { i: "c", x: 0, y: 0, w: 3.23, h: 1.5 },
    { i: "d", x: 3.37, y: 0, w: 3.23, h: 1 },
    { i: "e", x: 6.74, y: 0, w: 3.23, h: 1 },
  ];
  const layout2 = [
    { i: "a", x: 0, y: 0, w: 4.00, h: 1 },
    { i: "b", x: 0, y: 0, w: 4.00, h: 1 },
    { i: "c", x: 0, y: 0, w: 4.00, h: 1},
    { i: "d", x: 0, y: 0, w: 4.00, h: 1 },
    { i: "e", x: 0, y: 0, w: 4.00, h: 1 },
  ];
  



    if (widthscreen > breakpoint) {
      return (
        <RGridLayout
          className="layout"
          layouts={{ lg: layout, xs: layout2 }}
          autoSize={true}
          useCSSTransforms
          onBreakpointChange={() => {
            console.log("changed");
          }}
          // style={{transform: 'translate(-24px, -24px)'}}
          margin={{ lg: [24, 24], xs: [24, 24] }}
          breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480 }}
          cols={{ lg: 12, md: 10, sm: 8, xs: 4 }}
          rowHeight={265}
          isDraggable={false}
        >
          <div key="a" >
            {widget1}
          </div>
          <div key="b" >
            {widget2}
          </div>
          <div key="c" style={{ marginTop: "14px" }}>
            {widget3}
          </div>
          <div key="d" style={{ marginTop: "14px" }}>
            {widget4}
          </div>
          <div key="e" style={{ marginTop: "14px" }}>
            {widget5}
          </div>
        </RGridLayout>
      );
    } else {
      return (
        <RGridLayout
          className="layout"
          layouts={{ lg: layout, xs: layout2 }}
          autoSize={true}
          useCSSTransforms
          onBreakpointChange={() => {
            console.log("changed");
          }}
          // style={{transform: 'translate(-24px, -24px)'}}
          margin={{ lg: [24, 24], xs: [24, 24] }}
          breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480 }}
          cols={{ lg: 12, md: 10, sm: 8, xs: 4 }}
          rowHeight={265}
          isDraggable={false}
        >
          <div key="a" style={{ marginTop: "14px" }}>
            {widget1}
          </div>
          <div key="b" style={{ marginTop: "14px" }}>
            {widget2}
          </div>
          <div key="c" style={{ marginTop: "14px" }}>
            {widget3}
          </div>
          <div key="d" style={{ marginTop: "14px" }}>
            {widget4}
          </div>
          <div key="e" style={{ marginTop: "14px" }}>
            {widget5}
          </div>
        </RGridLayout>
      );
    }

};

export default DashboardLayout;
